import { createSelector } from 'reselect';
import { PWAReducerName } from './constants';
import { initialState } from './reducer';
var pwaStorageSelector = function (store) {
    return store[PWAReducerName] || initialState;
};
export var pwaPromptIosSelector = createSelector([pwaStorageSelector], function (_a) {
    var pwaPromptPwaIos = _a.pwaPromptPwaIos;
    return pwaPromptPwaIos;
});
export var pwaAndroidEventSelector = createSelector([pwaStorageSelector], function (_a) {
    var pwaPromptAndroidEvent = _a.pwaPromptAndroidEvent;
    return pwaPromptAndroidEvent;
});
export var pwaPromptIsShownSelector = createSelector([pwaStorageSelector], function (_a) {
    var pwaPromptPwaIos = _a.pwaPromptPwaIos, pwaPromptAndroidEvent = _a.pwaPromptAndroidEvent;
    return pwaPromptAndroidEvent || pwaPromptPwaIos;
});
export var pwaModalIosShownSelector = createSelector([pwaStorageSelector], function (_a) {
    var pwaModalIosShown = _a.pwaModalIosShown;
    return pwaModalIosShown;
});
export var manifestSelector = createSelector([pwaStorageSelector], function (_a) {
    var manifest = _a.manifest;
    return manifest;
});
